/**
 * Modal Component
 * Reusable modal dialog
 */

import { useEffect, useCallback } from 'react'
import { X } from 'lucide-react'

export function Modal({ isOpen, onClose, title, icon, customHeader, children, footer }) {
  // ESCキーで閉じる
  const handleEscape = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose?.()
    }
  }, [onClose])

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = ''
    }
  }, [isOpen, handleEscape])

  if (!isOpen) return null

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="modal">
        {customHeader ? (
          <div className="modal-header modal-header-custom">
            {customHeader}
            <button
              className="modal-close"
              onClick={onClose}
              aria-label="閉じる"
            >
              <X size={18} />
            </button>
          </div>
        ) : (
          <div className="modal-header">
            {icon && <img src={icon} alt="" className="modal-header-icon" />}
            <h2 className="modal-title" id="modal-title">{title}</h2>
            <button
              className="modal-close"
              onClick={onClose}
              aria-label="閉じる"
            >
              <X size={18} />
            </button>
          </div>
        )}

        <div className="modal-body">
          {children}
        </div>

        {footer && (
          <div className="modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}

export default Modal
